import { ReactComponent as FilterIcon } from '../../../../assets/img/icons/filter.svg';

import './filterIcon.scss';

const FilterDropdownIcon = ({ filtered }) => {
  return filtered ? <FilterIcon className={'filter-icon active'} /> : <FilterIcon className={'filter-icon'} />;
};

export default FilterDropdownIcon;
